// =====================================================
// SCHEMA: EMAIL
// Description: Schéma Zod pour l'envoi d'emails
// =====================================================

import { z } from 'zod';

export const sendEmailSchema = z.object({
  to: z.array(z.string().email('Email invalide')).min(1, 'Au moins un destinataire requis'),
  cc: z.array(z.string().email('Email invalide')).optional(),
  subject: z.string().min(1, 'Sujet requis'),
  body: z.string().min(1, 'Message requis'),
});

export type SendEmailInput = z.infer<typeof sendEmailSchema>;
